export default "__VITE_ASSET__Chra2rrC__"